/** Build the `/clients/:id` route. */

export function clientPath(id?: string | null): string {
    const trimmed = String(id || '').trim();
    if (!trimmed)
        return '/clients';
    return `/clients/${encodeURIComponent(trimmed)}`;
}
